export const WorkspaceMenuTestIdFactory = {
    getDeveloperToolsItemTestId: () => 'developer-tools',
};
